import React from "react";

const Java_Modifiers = () => {
  return (
    <div>
      <h1>Java Modifiers</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Modifiers in Java.</p>
    </div>
  );
};

export default Java_Modifiers;
